import Vue from "vue";
import Component from "vue-class-component";
import {Groupe, Societe, Profil} from "@/shared/Groupe";
import {Site} from "@/shared/Site";
import _ from "lodash";
import {Enseigne} from "@/shared/Enseigne";

@Component
export default class ConfigMixin extends Vue {

  get groupes(): Groupe[] {
    return this.$store.getters["config/groupes"];
  }

  get societes(): Societe[] {
    return this.$store.getters["config/societes"];
  }

  get enseignes(): Enseigne[] {
    return this.$store.getters["login/enseignes"];
  }

  get sites(): any {
    return this.$store.getters["login/sites"];
  }

  public groupesFiltered(selectedElem: any) {
    // console.log(this.selectedProfil);
    const rs = selectedElem.societesPlus.map((soc: any) => soc.raisonSociale);
    // console.log(rs);
    return this.groupes.filter(
      (groupe: Groupe) => rs.indexOf(groupe.raisonSociale) === -1
    );
  }

  public groupesFilteredMoins(selectedElem: any) {
    const rs = selectedElem.societesMoins.map((soc: any) => soc.raisonSociale);
    return this.groupes.filter(
      (groupe: Groupe) => rs.indexOf(groupe.raisonSociale) === -1
    );
  }

  public societesFiltered(selectedElem: any) {
    const mesSocs =
      this.societes.length > 0
        ? this.societes
        : JSON.parse(localStorage.societes);

    const itemsToExclude = new Set();

    // Ajout des sociétés plus
    selectedElem.societesPlus.forEach((raison: any) => {
      itemsToExclude.add(`${raison.raisonSociale}|${raison.restaurantId}`);
    });

    // Ajout des sociétés moins
    selectedElem.societesMoins.forEach((raison: any) => {
      itemsToExclude.add(`${raison.raisonSociale}|${raison.restaurantId}`);
    });

    // Filtrage avec un séparateur unique pour éviter les ambiguïtés
    const filteredSocs = mesSocs.filter(
      (soc: any) => !itemsToExclude.has(`${soc.raisonSociale}|${soc.restaurantId}`)
    );

    const enseigneObj: any = {};
    this.resIdToEnseignes(enseigneObj);

    const alphaObj: any = {};
    this.resIdToCodeAlpha(alphaObj);

    let socs = filteredSocs.map((soc: any) => {
      const enseigne = enseigneObj[soc.restaurantId] || "";

      if (enseigne) {
        soc.libelle = `${enseigne} - ${soc.raisonSociale} - ${soc.restaurantId}`;
      } else {
        soc.libelle = `${soc.raisonSociale} - ${soc.restaurantId}`;
      }

      return soc;
    });

    socs = _.sortBy(socs, [(o: any) => o.raisonSociale + o.restaurantId]);

    return socs;
  }

  public societesFilteredMoins(selectedElem: any) {
    const mesSocs =
      this.societes.length > 0
        ? this.societes
        : JSON.parse(localStorage.societes);

    const itemsToExclude = new Set();

    // Ajout des sociétés plus
    selectedElem.societesPlus.forEach((raison: any) => {
      itemsToExclude.add(`${raison.raisonSociale}|${raison.restaurantId}`);
    });

    // Ajout des sociétés moins
    selectedElem.societesMoins.forEach((raison: any) => {
      itemsToExclude.add(`${raison.raisonSociale}|${raison.restaurantId}`);
    });

    const filteredSocs = mesSocs.filter(
      (soc: any) => !itemsToExclude.has(`${soc.raisonSociale}|${soc.restaurantId}`)
    );

    const enseigneObj: any = {};
    this.resIdToEnseignes(enseigneObj);

    const alphaObj: any = {};
    this.resIdToCodeAlpha(alphaObj);

    let socs = filteredSocs.map((soc: any) => {
      const enseigne = enseigneObj[soc.restaurantId] || "";

      if (enseigne) {
        soc.libelle = `${enseigne} - ${soc.raisonSociale} - ${soc.restaurantId}`;
      } else {
        soc.libelle = `${soc.raisonSociale} - ${soc.restaurantId}`;
      }

      return soc;
    });

    socs = _.sortBy(socs, [(o: any) => o.raisonSociale]);
    return socs;
  }

  /**
   * methode de suppression d'une société des societes moins du groupe selectionné
   */
  public removeOneSiteEx(site: Societe, selectedEleme: any) {
    selectedEleme.societesMoins = selectedEleme.societesMoins.filter(
      (societe: Societe) => societe.id !== site.id
    );
  }

  /**
   * methode de suppression d'une société des societes plus du groupe selectionné
   */
  public removeOneSite(societeToDelete: Societe, selectedEleme: any) {
    selectedEleme.societesPlus = selectedEleme.societesPlus.filter(
      (societe: Societe) => societe.id !== societeToDelete.id
    );
  }

  /**
   * ajout d'un groupe plus au groupe selectionné
   */
  public addGrToGr(groupe: Groupe, selectedEleme: any) {
    selectedEleme.societesPlus.push(groupe);
  }

  /**
   * Ajout d'une société plus au groupe selectionné
   */
  public addSocietyToGroup(societe: string, selectedEleme: any) {
    this.addSocieteToArray(societe, selectedEleme, "societesPlus");
  }

  /**
   * ajout d'un groupe moins au groupe selectionné
   */
  public ExGrToGr(groupe: Groupe, selectedEleme: any) {
    selectedEleme.societesMoins.push(groupe);
  }

  /**
   * ajout d'une société moins au groupe selectionné
   */
  public excludeSocietyToGroup(societe: string, selectedEleme: any) {
    this.addSocieteToArray(societe, selectedEleme, "societesMoins");
  }

  /**
   * retourne l'enseigne par rapport au restaurantId donné
   * @param enseigneObj
   */
  public resIdToEnseignes(enseigneObj: any) {
    const enseignes = this.enseignes;
    enseignes.forEach((enseigne: Enseigne) => {
      if (enseigne.libelle && enseigne.libelle.trim() !== "") {
        enseigneObj[enseigne.restaurantId] = enseigne.libelle;
      }
    });
  }

  /**
   * Retourne le code alpha
   * @param alphaobj
   */
  public resIdToCodeAlpha(alphaobj: any) {
    const sites = this.sites;
    sites.forEach((site: Site) => {
      if (site.codeAlpha && site.codeAlpha.trim() !== "") {
        alphaobj[site.restaurantId] = site.codeAlpha;
      }
    });
  }

  /**
   * Ajoute une société au tableau spécifié de l'élément sélectionné
   * @param societe - Chaîne contenant l'ID de la société
   * @param selectedEleme - Élément auquel ajouter la société
   * @param targetArray - Nom du tableau cible ('societesPlus' ou 'societesMoins')
   */
  private addSocieteToArray(societe: string, selectedEleme: any, targetArray: "societesPlus" | "societesMoins"): void {
    const splitSoc = societe.split("-");
    const societeId = parseInt(splitSoc[splitSoc.length - 1]);
    const societeToAdd = this.societes.find(
      (soc: any) => soc.restaurantId === societeId
    );

    if (societeToAdd && selectedEleme[targetArray]) {
      selectedEleme[targetArray].push(societeToAdd);
    }
  }
}
